const colours = {
    // Names from https://chir.ag/projects/name-that-color/
    black: '#000000',
    lightGray: '#EBEBEB',
    gray: '#888888',
    darkGray: '#545454',
    Silver: '#CCCCCC',
    white: '#ffffff',
    mercury: '#E9E9E9',

    // Colours bespoke to ITV7 Sweeps
    dark: '#19262A',
    itv7Green: '#004226',
    itv7Orange: '#fa6019',
    itv7Brown: '#8B590E',

    // SkyBet brand colours
    skybetBlue: '#132C6C',

    // Share colours
    facebook: '#3b5998',
    x: '#000000',
    whatsapp: '#25d366',
    email: '#4f6175',
    copyLink: '#f7a20f'
};

export default {
    colours: {
        textWhite: colours.white,
        textGreen: colours.itv7Green,
        textOrange: colours.itv7Orange,
        textDark: colours.dark,

        background: {
            green: colours.itv7Green,
            orange: colours.itv7Orange
        },

        divider: {
            lightGray: colours.lightGray
        },

        skybet: {
            blue: colours.skybetBlue
        },

        share: {
            facebook: colours.facebook,
            x: colours.x,
            whatsapp: colours.whatsapp,
            email: colours.email,
            copyLink: colours.copyLink
        }
    },
    componentColours: {
        button: {
            default: {
                background: colours.itv7Orange,
                border: colours.itv7Brown,
                highlight: colours.itv7Brown
            },
            secondary: {
                background: colours.itv7Green,
                border: colours.itv7Green,
                highlight: colours.itv7Green
            }
        },
        home: {
            bgColour: colours.lightGray,
            rulesBgColour: colours.white
        },
        modal: {
            bgColour: colours.gray,
            text: colours.white
        },
        upcomingRounds: {
            divider: colours.itv7Orange
        },
        betPromo: {
            text: colours.white,
            bgColour: colours.skybetBlue
        }
    },
    spacing: {
        xsmall: '4px',
        small: '6px',
        normal: '8px',
        medium: '10px',
        large: '16px',
        xlarge: '24px',
        xxlarge: '48px',
        huge: '80px'
    },
    fonts: {
        regular: '"Sky Regular", Arial, sans-serif',
        medium: '"Sky Medium", Arial, sans-serif',
        italic: '"Sky Italic", Arial, sans-serif',
        skySportsBoldItalic: '"Sky Sports Bold Italic", Arial, sans-serif',
        bold: '"Sky Bold", Arial, sans-serif',
        gtWalsheimProBold: '"ITV Text Sans Bold", Arial, sans-serif',
        gtWalsheimProMedium: '"ITV Text Sans Medium", Arial, sans-serif',
        gtWalsheimProRegular: '"ITV Text Sans Regular", Arial, sans-serif',
        skycons: 'skycons',
        digital: 'Digital Numbers Regular'
    },
    fontSize: {
        xxxsmall: '8px',
        xxsmall: '10px',
        xsmall: '12px',
        small: '13px',
        normal: '14px',
        medium: '16px',
        large: '18px',
        large2: '20px',
        xlarge: '22px',
        xlarge2: '28px',
        xxlarge: '30px',
        huge: '36px',
        vhuge: '50px',
        vvhuge: '77px'
    },
    iconSize: {
        small: '9px',
        normal: '13px',
        large: '20px',
        xlarge: '36px'
    },
    lineHeight: {
        xsmall: 0.7,
        small: 1,
        normal: 1.42857,
        medium: 1.8,
        large: 2.2
    },
    widths: {
        tabletMax: '1023px',
        desktopMin: '1024px',
        mobileMax: '576px',
        containerMaxWidth: '987px',
        smallMobile: '350px'
    },
    spinner: {
        spinnerSize: '2',
        spinnerSizeSmall: '2',
        spinnerSizeLarge: '3',
        spinnerAnimationSpeed: '0.8s',
        spinnerTransitionDelay: '0.8s'
    }
};
